<template>
  <div>
    <select v-model="selectedTask">
      <option :value="null">Rerun from the start</option>
      <option
        v-for="workflowTask in workflowTasks"
        :key="workflowTask.taskId"
        :value="workflowTask"
      >
        {{ workflowTask.seq }} - {{ workflowTask.taskId }} -
        {{ workflowTask.status }} - {{ workflowTask.taskType }}
      </option>
    </select>
    <JsonEditor v-model="rerunPayload" />
    <button @click="rerunWorkflow(rerunPayload)">Rerun</button>
    <router-link
      tag="button"
      :to="{ name: 'workflow', params: { workflowId: workflowId } }"
    >
      Cancel
    </router-link>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import JsonEditor from '@/components/JsonEditor.vue'

// TODO Select a Task from Workflow to populate payload
export default {
  name: 'WorkflowRerun',
  props: ['workflowId'],
  data() {
    return {
      selectedTask: null,
      rerunPayload: {
        reRunFromWorkflowId: null,
        workflowInput: null,
        reRunFromTaskId: null,
        taskInput: null,
        correlationId: null
      }
    }
  },
  computed: {
    ...mapGetters({
      workflowTasks: 'workflowTasksOrderBySeq'
    }),
    ...mapState(['workflow'])
  },
  methods: {
    updateRerunPayload: function() {
      if (this.workflow)
        this.rerunPayload = Object.assign({}, this.rerunPayload, {
          correlationId: this.workflow.correlationId || null,
          workflowInput: this.workflow.input || null
        })
    },
    ...mapActions(['getWorkflow', 'rerunWorkflow'])
  },
  created() {
    this.getWorkflow(this.workflowId)
  },
  watch: {
    workflowId: function() {
      this.getWorkflow(this.workflowId)
    },
    selectedTask: function() {
      if (this.selectedTask) {
        this.rerunPayload.reRunFromTaskId = this.selectedTask.taskId
        this.rerunPayload.taskInput = this.selectedTask.inputData
      } else {
        this.rerunPayload.reRunFromTaskId = null
        this.rerunPayload.taskInput = null
      }
    },
    workflow: function() {
      this.updateRerunPayload()
    }
  },
  components: {
    JsonEditor
  }
}
</script>
